import Button from '@mui/material/Button';
import { styled, keyframes } from '@mui/system';

const shineAnimation = keyframes`
  0% {
    transform: translateY(-150%);
    opacity: 0.4;
  }
  50% {
    transform: translateY(0%);
    opacity: 0.8;
  }
  100% {
    transform: translateY(150%);
    opacity: 0;
  }
`;

export const CircularButton = styled(Button)({
  minWidth: '3.5rem',
  minHeight: '3.5rem',
  width: '3.5rem',
  height: '3.5rem',
  borderRadius: '50%',
  backgroundColor: '#fff',
  color: '#000',
  border: '1px solid #000',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.4) !important",
  position: 'relative',
  overflow: 'hidden',
  '@media (max-width: 620px)': {
    minWidth: '2.6rem',
    minHeight: '2.6rem',
    width: '2.6rem',
    height: '2.6rem',
  },
  '&:hover': {
    backgroundColor: '#fff',
  },

  '&::before': {
    content: '""',
    position: 'absolute',
    top: '-50%',
    left: 0,
    right: 0,
    bottom: '-50%',
    background: 'linear-gradient(transparent, rgba(255, 255, 255, 0.55), transparent)',
    width: '100%',
    height: '200%',
    transform: 'translateY(-150%)',
    opacity: 0,
    borderRadius: '50%',
    animation: `${shineAnimation} 2.5s infinite`,
  },
});
